var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title != '')?_c('div',{staticClass:"title"},[_vm._v("\n\t"+_vm._s(_vm.title)+"\n")]):_c('div',{staticClass:"tip_view"},[_vm._v("\n\tTip："+_vm._s(_vm.tip)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }